import Vue from 'vue'
import VueRouter from 'vue-router'
import home from './home'
import  my from './my'
import course from './course'
import login from "./login";
import newcourse from "./newcourse"

Vue.use(VueRouter)

const routes = [
  ...home,
  ...my,
  ...course,
    ...login,
    ...newcourse
]

const router = new VueRouter({
  routes
})
//跳转页面默认回到顶部
router.afterEach(() => {
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
})

export default router
